import * as yup from "yup";

import { IInvoiceSettings } from "../../interfaces-and-types";

export const invoiceValidationSchema: yup.SchemaOf<IInvoiceSettings> = yup
  .object({
    payment_default_memo: yup.string().nullable().required(),
    receipt_and_invoice_default_memo: yup.string().nullable().required(),
    invoice_days_to_payment_due_default: yup.number().nullable().required(),
  })
  .required();
